<template>
  <div class='row no-wrap'>
      <div class='q-mt-lg col-6'>
          <q-card>
                <div class='row no-wrap q-pa-md full-width q-body-2 text-center bg-primary text-white' >
                    <div class='col-1'>
                        #
                    </div>
                    <div class='col-2 ellipsis-2-lines'>
                        Дата прихода
                    </div>
                    <div class='col-3 ellipsis-2-lines'>
                        Сумма платежа
                    </div>
                    <div class='col-4 ellipsis-2-lines'>
                        Тип платежа
                    </div>
                    <div class='col-2 ellipsis-2-lines'>
                        Продлено до
                    </div>
                </div>

              <div v-for="(item,key) in getAllPay" :key=key class='q-body-2'>
                  <div class='row no-wrap q-pa-md full-width text-center bg-grey-2'>

                      <div class='col-1'>
                          {{ (key+1) }}
                      </div>
                      <div class='col-2 text-center ellipsis-2-lines'>
                         {{ getPrettyDate(payOptions(item).when) }}
                      </div>
                      <div class='col-3 ellipsis-2-lines'>
                          {{ payOptions(item).cash }} р.
                      </div>
                      <div class='col-4 ellipsis-2-lines'>
                          {{ payOptions(item).type }}
                      </div>
                      <div class='col-2 ellipsis-2-lines'>
                          {{ getPrettyDate(payOptions(item).active_to) }}
                      </div>

                  </div>
              </div>
          </q-card>
      </div>
      <div class='q-ml-lg q-mt-lg col-5'>
          <q-card>
              <div class="row bg-positive text-white q-pa-md no-wrap">
                  Запрос счета на оплату
              </div>
              <div class="row justify-around q-pa-md items-center">
                  <div>
                      <q-icon name="fas fa-comment-dollar" size="70px" color='primary' class='q-mr-sm'/>
                  </div>
                  <div>
                    <q-option-group
                        color="secondary"
                        type="radio"                        
                        v-model="payPeriod"
                        :options="[
                            { label: 'Оплата за мес (2000 р)', value: '1' },
                            { label: 'Оплата за 6 мес (скидка 5%)', value: '2' },
                            { label: 'Оплата за 12 мес (скидка 10%)', value: '3' }
                        ]"
                    />
                    <q-card-separator/>
                    <div class='q-caption text-grey-8 q-mt-sm'>Итого: {{ itogPay }} р.</div>
                  </div>
              </div>
              <div class='row justify-center'>
                  <q-btn label='Запросить счет' color='primary' class='q-mb-md' @click="requestBill" :loading="billRequested"/>
              </div>
          </q-card>
      </div>
  </div>
</template>

<script>
export default {
    name : 'userPaysComponent',
    data() {
        return {
            payPeriod : '1',
            monthCost : 2000,
            billRequested : false,
        }
    },
    created() {
        this.$store.dispatch('getUserPays')
        .then()
        .catch();
    },
    computed : {
        getAllPay() {
            return this.$store.getters.allUserPays
        },
        itogPay() {
            let result = this.monthCost;
            if (this.payPeriod == '2') result = this.monthCost*6*0.95;
            if (this.payPeriod == '3') result = this.monthCost*12*0.9;
            return result;
        },
    },
    methods : {
        requestBill() {
            this.billRequested = true;
            this.$store.dispatch('requestBill', {'payPeriod' : this.payPeriod})
            .then(()=>{
                this.$q.notify({
                    color: 'positive',
                    position: 'center',
                    message: 'Запрос отправлен успешно',
                    icon: 'report'
                });
                this.billRequested = false;
            })
            .catch((e)=> {
                if (e.response.status == 401) {
                    this.$router.push('logout')
                    return;
                }
                this.$q.notify({
                    color: 'negative',
                    position: 'center',
                    message: 'Ошибка при выполнении запроса к серверу',
                    icon: 'report'
                });
                this.billRequested = false;
            });
        },

        payOptions(pay) {
            return (pay.options) ? JSON.parse(pay.options) : {}
        },

        getPrettyDate(d) {
            let q = new Date(d);
            return q.toLocaleDateString();
        },
        getPayDate(pay) {
            let q = (pay.options) ? JSON.parse(pay.options) : {}
            let d = q.when ? new Date(q.when) : new Date('0000-00-00 00:00:00');
            return d.toLocaleDateString();
        }
    }


}
</script>

<style>

</style>